// extracted by mini-css-extract-plugin
export default {"add_card_btn":"styles_add_card_btn__kM2kx","svg_wrapper":"styles_svg_wrapper__3a1+j","btn_plus_icon":"styles_btn_plus_icon__soFh1"};